import { render, staticRenderFns } from "./outsource-token-calls.vue?vue&type=template&id=f2b60faa&"
import script from "./outsource-token-calls.vue?vue&type=script&lang=js&"
export * from "./outsource-token-calls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports